import { Mutator } from '@/util/import/MutatorFactory'
import { IEntryExported } from '@/types/entry'

class Importer {
    private input: string | null = null

    /**
     * Read a file async. Await this before
     * generating the import data
     *
     * @param {File} file
     * @returns {Promise<void>}
     */
    public async readFile(file: File): Promise<void> {
        this.setInput(await new Promise<string>((resolve) => {
            const reader = new FileReader()
            reader.onload = () => {
                resolve(reader.result as string)
            }
            reader.readAsText(file)
        }))
    }

    public setInput(input: string) {
        this.input = input
    }

    public mutate(mutator: Mutator): IEntryExported[] {
        if (!this.input) {
            return []
        }
        return mutator(this.input)
    }
}
export default new Importer()
